module.exports = __webpack_public_path__ + "static/img/B (31).1bfa4178.png";